import React, { Component } from "react";
import {
  Row,
  Col,
  Button,
  FormControl,
  Form,
  Modal,
  Alert,
  InputGroup,
} from "react-bootstrap";
import {
  listarSeparadores,
  CadastrarSeparador,
  DeletarSeparador,
  EditarSeparador,
} from "../../providers/SeparadorProvider";
import TBLSeparadores from "../../components/TBLSeparadores";
import { getUser } from "../../services/Auth";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import { BuscarSeparadorPorNomeOuCpf } from "../../providers/BuscaProvider";

export default class Separador extends Component {
  constructor(props) {
    super(props);
    this.state = {
      separadorSelecionado: null,
      showModalSeparador: false,
      showModalAlert: false,
      errorCadastro: "",
      modoEditarSeparador: false,
      validarCPF: false,

      separadores: [],
      nome: null,
      cpf: null,
      errorCpf: "",
      email: null,
      senha: "",

      mensagemAlert: "",
      variantAlert: "",
    };
  }

  handleCloseModalSeparador = () => {
    this.setState({ showModalSeparador: false });
    this.limparForm();
  };

  handleShowModalSeparador = () => {
    this.setState({ showModalSeparador: true });
  };

  handleShowAlert = (mensagem, variant) => {
    if (variant === "success") {
      toast.success(mensagem);
    } else {
      toast.error(mensagem);
    }
  };

  handleCloseModalAlert = () => {
    this.setState({ showModalAlert: false });
    this.limparForm();
  };

  handleShowModalAlert = () => {
    this.setState({ showModalAlert: true });
  };

  validarCPF = (cpf) => {
    let Soma = 0;
    let Resto;
    if (cpf === "00000000000") {
      return false;
    }
    for (let i = 1; i <= 9; i++) {
      Soma = Soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
    }
    Resto = (Soma * 10) % 11;
    if (Resto === 10 || Resto === 11) {
      Resto = 0;
    }
    if (Resto !== parseInt(cpf.substring(9, 10))) {
      return false;
    }
    Soma = 0;
    for (let i = 1; i <= 10; i++) {
      Soma = Soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
    }
    Resto = (Soma * 10) % 11;
    if (Resto === 10 || Resto === 11) {
      Resto = 0;
    }
    if (Resto !== parseInt(cpf.substring(10, 11))) {
      return false;
    }
    return true;
  };

  limparForm = () => {
    this.setState({
      separadorSelecionado: null,
      showModalSeparador: false,
      showModalAlert: false,
      errorCadastro: "",
      modoEditarSeparador: false,

      nome: "",
      cpf: "",
      email: "",
      senha: "",
      errorCpf: "",

      mensagemAlert: "",
      variantAlert: "",
    });
  };

  preencherFormEdit = (dados) => {
    this.setState({
      separadorSelecionado: dados,
      nome: dados.nome,
      cpf: dados.cpf,
      email: dados.usuario.email,
      senha: "",
      modoEditarSeparador: true,
    });
    this.handleShowModalSeparador();
  };

  receberDadosTabela = (tipo, dados) => {
    if (tipo === "editar") {
      this.preencherFormEdit(dados);
    } else if (tipo === "deletar") {
      this.setState({ separadorSelecionado: dados });
      this.handleShowModalAlert();
    } else {
      return;
    }
  };

  cadastrarSeparador = async () => {
    let formSeparador = {};
    let formUsuario = {};
    const user = await getUser();
    if (!this.state.validarCPF) {
      this.setState({ errorCpf: "CPF invalido" });
      return;
    } else {
      this.setState({ errorCpf: "" });
    }
    if (
      this.state.nome === null ||
      this.state.cpf === null ||
      this.state.email === null ||
      this.state.senha === "" ||
      !this.state.validarCPF
    ) {
      this.setState({ errorCadastro: "Informações obrigatórias faltando" });
      return;
    } else {
      formSeparador = {
        nome: this.state.nome,
        cpf: this.state.cpf,
        estabelecimento: user.estabelecimento._id,
      };
      formUsuario = {
        email: this.state.email,
        senha: this.state.senha,
        tipo: "separador",
      };
      try {
        const response = await CadastrarSeparador(formSeparador, formUsuario);
        if (response) {
          const list = await listarSeparadores();
          this.setState({ separadores: list.docs });
          this.limparForm();
          this.handleShowAlert("Separador cadastrado com sucesso", "success");
        }
      } catch (error) {
        this.handleShowAlert("Erro ao cadastrar separador", "danger");
      }
    }
  };

  editarSeparador = async (separador) => {
    let formSeparador = {};
    let formUsuario = {};

    if (
      this.state.nome === null ||
      this.state.cpf === null ||
      this.state.email === null
    ) {
      this.setState({ errorCadastro: "Informações obrigatórias faltando" });
    } else {
      formSeparador = {
        nome: this.state.nome,
        cpf: this.state.cpf,
      };
      formUsuario = {
        email: this.state.email,
        senha: this.state.senha,
      };
      try {
        const response = await EditarSeparador(
          formSeparador,
          formUsuario,
          separador._id,
          separador.usuario._id,
        );
        if (response) {
          const list = await listarSeparadores();
          this.setState({ separadores: list.docs });
          this.limparForm();
          this.handleShowAlert("Separador editado com sucesso", "success");
        }
      } catch (error) {
        this.handleShowAlert("Erro ao editar separador", "danger");
      }
    }
  };

  deletarSeparador = async (separador) => {
    try {
      const response = await DeletarSeparador(separador._id);

      if (response) {
        const list = await listarSeparadores();
        this.setState({ separadores: list.docs });
        this.limparForm();
        this.handleShowAlert("Separador deletado com sucesso", "success");
      }
    } catch (error) {
      this.handleShowAlert("Erro ao deletar separador", "danger");
    }
  };

  listarSeparadores = async () => {
    const { docs } = await listarSeparadores();
    this.setState({ separadores: docs });
  };

  async componentDidMount() {
    await this.listarSeparadores();
  }

  buscarSeparadores = async (busca) => {
    if (busca) {
      const response = await BuscarSeparadorPorNomeOuCpf(busca);
      this.setState({ separadores: response });
    } else {
      await this.listarSeparadores();
    }
  };

  render() {
    return (
      <div>
        {this.state.showAlert ? (
          <Alert style={{ zIndex: 99999999999 }} variant={this.state.variantAlert}>
            {this.state.mensagemAlert}
          </Alert>
        ) : null}
        <br></br>
        <Row>
          <Col md={9}>
            <h3>Separadores</h3>
          </Col>
          <Col>
            <Button
              onClick={() => {
                this.handleShowModalSeparador();
              }}
            >
              Cadastrar Separador
            </Button>
          </Col>
        </Row>
        <br></br>

        <div>
          <InputGroup>
            <InputGroup.Prepend>
              <InputGroup.Text>
                <FontAwesomeIcon icon={faSearch}></FontAwesomeIcon>
              </InputGroup.Text>
            </InputGroup.Prepend>
            <FormControl
              placeholder="Pesquisar separadores por nome ou CPF"
              onChange={(e) => this.buscarSeparadores(e.target.value)}
            />
          </InputGroup>
          <TBLSeparadores
            data={this.state.separadores}
            numRows={13}
            dataCallback={this.receberDadosTabela}
          ></TBLSeparadores>
        </div>

        <Modal
          size="xl"
          show={this.state.showModalSeparador}
          onHide={this.handleCloseModalSeparador}
        >
          <Modal.Header closeButton className="modalHeader">
            <Modal.Title>
              {this.state.modoEditarSeparador
                ? "Editar Separador"
                : "Cadastrar Separador"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.errorCadastro ? (
              <div>
                <p style={{ color: "red" }}>{this.state.errorCadastro}</p>
              </div>
            ) : null}
            <Form>
              <Form.Group>
                <Form.Label>Nome *</Form.Label>
                <Form.Control
                  value={this.state.nome}
                  type="text"
                  placeholder="Nome do Separador"
                  onChange={(e) => {
                    this.setState({ nome: e.target.value });
                  }}
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>CPF *</Form.Label>
                <Form.Control
                  value={this.state.cpf}
                  maxLength={11}
                  type="text"
                  placeholder="CPF do Separador"
                  onChange={(e) => {
                    this.setState({ cpf: e.target.value });
                    const res = this.validarCPF(e.target.value);
                    this.setState({ validarCPF: res });
                  }}
                />
                {this.state.errorCpf ? (
                  <div>
                    <p style={{ color: "red" }}>{this.state.errorCpf}</p>
                  </div>
                ) : null}
              </Form.Group>
              <Form.Group>
                <Form.Label>Email</Form.Label>
                <Form.Control
                  value={this.state.email}
                  type="email"
                  placeholder="Email"
                  onChange={(e) => {
                    this.setState({ email: e.target.value });
                  }}
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>Senha *</Form.Label>
                <Form.Control
                  value={this.state.senha}
                  type="password"
                  min={1}
                  placeholder="Senha"
                  onChange={(e) => {
                    this.setState({ senha: e.target.value });
                  }}
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                this.handleCloseModalSeparador();
              }}
            >
              Fechar
            </Button>
            {this.state.modoEditarSeparador ? (
              <Button
                variant="primary"
                onClick={() => {
                  this.editarSeparador(this.state.separadorSelecionado);
                }}
              >
                {"Editar"}
              </Button>
            ) : (
              <Button
                variant="primary"
                onClick={() => {
                  this.cadastrarSeparador();
                }}
              >
                {"Cadastrar"}
              </Button>
            )}
          </Modal.Footer>
        </Modal>

        <Modal
          size="sm"
          show={this.state.showModalAlert}
          onHide={this.handleCloseModalAlert}
        >
          <Modal.Header closeButton>
            <Modal.Title>Alerta</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Deseja realmente excluir o Separador?</p>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                this.handleCloseModalAlert();
              }}
            >
              Não
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                this.deletarSeparador(this.state.separadorSelecionado);
              }}
            >
              Sim
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
